<template>
  <a-modal :visible="visible"
           @ok="handleOk"
           @cancel="cancelRecharge"
           centered
           footer
           :width="500"
           title="">
    <div class="payment-modal-content">
      <div class="icon-title">
        <div class="aliPay_icon"></div>
        <div class="icon-title-text">{{ $t('AccountInfo.BalanceRechargeAlipay.alipayPayment') }}</div>
      </div>
      <div class="placeholder-text">
        {{ $t('AccountInfo.BalanceRechargeAlipay.scanToPay') }}
      </div>

      <div class="qr-code">
        <iframe :src="props.url"
                title="Alipay QR Code"
                class="qr-code-placeholder"
                width="250"
                height="250">
        </iframe>
      </div>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref, watch } from 'vue'
import { getStatusFromAlipayRecharge } from '../api/balance'

const pollingIntervalId = ref()
const isPolling = ref(false)

const startPolling = () => {

  if (pollingIntervalId.value) return

  pollingIntervalId.value = setInterval(async () => {

    if (isPolling.value) return
    isPolling.value = true // 设置轮询状态为进行中

    try {
      const result = await getStatusFromAlipayRecharge(props.orderNumber)
      if (result.status === 1 || result.status === 0) {
        handleCancel()  // 关闭模态框
      }
    } catch (error) {
      console.error('查询失败:', error)
    } finally {
      isPolling.value = false // 轮询完成，重置状态
    }
  }, 2000)
}

const stopPolling = () => {
  if (pollingIntervalId.value) {
    clearInterval(pollingIntervalId.value)
    pollingIntervalId.value = null
  }
  isPolling.value = false // 停止时重置轮询状态

}

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  url: {
    type: String,
    required: true
  },
  orderNumber: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['close'])

const handleOk = () => {
  emit('close')
}

const handleCancel = () => {
  stopPolling()
  emit('close')
}

const cancelRecharge = async () => {
  stopPolling()
  await getStatusFromAlipayRecharge(props.orderNumber, 'true').then(() => {
    emit('close')
  })
}


onMounted(() => {
  if (props.visible) {
    nextTick(() => {
      startPolling()
    })
  }
})

watch(() => props.visible, async (newValue) => {
  if (newValue) {
    await nextTick()
    startPolling()
  } else {
    stopPolling()
  }
})
</script>


<style scoped lang="less">
.payment-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 50px;
}

.icon-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.aliPay_icon {
  width: 34px;
  /* 图标的宽度 */
  height: 34px;
  /* 图标的高度 */
  background: url(".././view/assets/imgs/balanceRecharge_alipay.png") no-repeat center / contain;
  /* 使用背景图 */
}

.icon-title-text {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 24px;
  color: #111111;
  margin-left: 10px;
}

.placeholder-text {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  margin-bottom: 25px;
}



.qr-code {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 250px;
  height: 250px;
  margin-left: 35px;
  padding: 0;
}

.qr-code-placeholder {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
